// -*- js-indent-level: 4; -*-
// Makes all the `subSel` items in the jQuery collection wholy clickable, following `linkSel`

import '../../css/src/main.scss';

import initHeader from "./lib/header.js";
import relativeDates from "./lib/relative-dates.js";
import loadMASession from "./lib/load-ma-session.js";
import processConsent from "./lib/process-consent.js";

const $ = jQuery.noConflict();

$.fn.clickWhole = function (subSel, linkSel) {
  return $(this)
    .on("click", subSel, function (event) {
      if ($(event.target).is("a")) {
        window.location.href = $(event.target).attr("href");
      } else {
        event.stopPropagation();
        event.preventDefault();
        $(this).find(linkSel).click();
      }
    })
    .find(subSel)
    .addClass("click-whole")
    .end();
};

function gotoSearchResults() {
  window.location.href = $(".showSearchResults").attr("href");
}

function initSearch() {
  let $input = $("header input.search");
  let $results = $("header .searchResults");
  let searchTimer;

  let fetchAndShowSearchRecommendations = () => {
    $results.addClass("open").addClass("loading");
    searchRecommendation()
      .then((data) => {
        let html = "";
        if (data.length > 0) {
          html = data
            .map((k) => `<a href="${k.link}" class="${k.type}">${k.title}</a>`)
            .join("");
        } else {
          html = `<span class="warning">Nichts gefunden</span>`;
        }
        $results.find(".recomendations").html(html);
      })
      .finally(() => {
        $results.removeClass("loading");
      });
  };

  // close search results when clicking outside
  $(document).on("click", function (e) {
    if (
      !$(e.target).closest("header .searchResults").length &&
      $(e.target).closest("input.search").length == 0
    ) {
      $results.removeClass("open");
    }
  });

  $input.on("keyup", function (event) {
    let val = $input.val();
    $results
      .find(".showSearchResults")
      .attr("href", `/?s=${encodeURIComponent(val)}`);
    if (event.keyCode == 13 && val != "") gotoSearchResults();
    if (val == "") {
      clearTimeout(searchTimer);
      $results.removeClass("open");
      return;
    }
    if (searchTimer !== undefined) clearTimeout(searchTimer);
    searchTimer = setTimeout(fetchAndShowSearchRecommendations, 300);
  });
}

function initEventHandlers() {
  $(".reg").on("click", function (e) {
    e.preventDefault();
    $(".headerLogin").removeClass("open");
  });
}

const badExchanges = ["LSE", "XETR", "FWB", "DUS", "MUN", "BER", "MIL", "HAM"];

function initTradingView() {
  $("[data-tv-symbol]:visible:not(.tv-initialized)").each(function () {
    var config = $(this).addClass('tv-initialized');
    var id = "tradingview_" + Math.floor(Math.random() * 1000000);
    var symbol = config.data("tv-symbol");
    var symbolUri = symbol.replace(":", "-");

    var width = Math.floor(config.data("width") || Math.min(config.innerWidth(), window.innerWidth - 20));
    var height = Math.floor(config.data("height") || config.innerHeight());
    var interval = config.data("interval") || "3M";
    var autosize = config.data("autosize") ? true : false;
    var disableCopyright = config.data("disable-copyright") ? true : false;
    var stockProfileStyle = config.data("style") === "stock-profile";
    var stockAufmacherStyle = config.data("style") === "stock-aufmacher";
    var mini = stockAufmacherStyle;
    var se = symbolUri.split("-")[0] || "KEKSE";

    // Quickfix for TV not showing day-data on some german stack exchanges.
    if (badExchanges.indexOf(se) > -1) {
      interval = "1Y";
      console.warn(`Can only show yearly data for ${se}`);
    }

    var params = {
      symbols: [[symbol, symbol + "|" + interval]],
      chartOnly: false,
      width: width,
      height: height,
      colorTheme: "light",
      timezone: "Etc/UTC",
      gridLineColor: "rgb(164, 194, 244)",
      trendLineColor: "#2196F3",
      fontColor: "#787B86",
      scalePosition: "right",
      scaleMode: "normal",
      underLineColor: "#E3F2FD",
      autosize: false,
      container_id: id,
    };

    if (stockAufmacherStyle) {
      params["hide_top_toolbar"] = true;
      params["hide_legend"] = true;
      params["save_image"] = false;
      params["width"] = width;
      params["height"] = config.height();
      params["isTransparent"] = true;
      params["chartOnly"] = false;
      params["scalePosition"] = "none";
      // Hides the "Quotes by TradingView". Both of them.
      params["whitelabel"] = true;
    }

    if (autosize) {
      if (stockProfileStyle) {
        params["autosize"] = true;
        params["hide_top_toolbar"] = true;
        params["hide_legend"] = true;
        params["save_image"] = false;
      }
    } else {
      params["width"] = width;
      params["height"] = height;
    }

    const tvBase = "https://s3.tradingview.com/external-embedding/";
    const script = document.createElement("script");
    if (mini) {
      script.src = tvBase + "embed-widget-mini-symbol-overview.js";
      params["symbol"] = params["symbols"][0][0];
      params["dateRange"] = interval;
    } else {
      script.src = tvBase + "embed-widget-symbol-overview.js";
    }
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = JSON.stringify(params);

    var copyright =
      '<div class="tradingview-widget-copyright">' +
      '<a href="https://de.tradingview.com/symbols/' +
      symbolUri +
      '/" target="_blank" rel="noopener noreferrer">' +
      '<span class="blue-text">' +
      (symbolUri.split("-")[1] || symbolUri) +
      " Chart</span>" +
      "</a> von TradingView" +
      "</div>";

    $(this).html('<div class="tradingview-widget-container"></div>');

    this.firstChild.appendChild(script);
    if (!disableCopyright) {
      $(this).append(copyright);
    }
  });
}

/*
  function initChat() {
  $("chat").each(function() {
  var config = $(this);
  var roomUri = config.data('room-id') ? 'room/' + config.data('room-id') : '';
  var height = config.data('height') || 900;
  $(this).html('<iframe style="border: 0px solid grey;" src="https://live.sharedeals.de/' + roomUri + '" width="100%" height="' + height + '" frameborder="0">');
  });
  }
*/

/*
Without this field, the newsletter subscription always succeeds, swallowing all
values, including non-email addresses. We guess that is a protection from
spammers and bots, so they add another field using JS.
We reimplemeted that code using jquery to avoid another HTTP request to download the original js.
From: https://klicktipp.s3.amazonaws.com/listbuildings/system/forms/scripts/protect.js
*/
const protectKlickTippForm = () => {
  $("[name=apikey]").each(function () {
    $("<input />")
      .attr("type", "hidden")
      .attr("name", "fields[fieldHomepage]")
      .val("klicktipp.com")
      .appendTo($(this).parent());
  });
};

const detectMobile = () => window.innerWidth <= 900;

if (!document.location.pathname.startsWith("/wp-admin/")) {
  jQuery(document).ready(function () {
    initHeader();
    initSearch();
    initEventHandlers();
    relativeDates();
    processConsent();

    //initChat();
    document.addEventListener("DOMContentLoaded", function (event) {
      document.querySelectorAll("img").forEach(function (img) {
        img.onerror = function () {
          this.style.display = "none";
        };
      });
    });
    if ($(".slide").length == 0) {
      $(".newArticles .containerTitle").css("margin-top", 0);
      $(".newArticles .containerTitle").css("padding-top", 0);
    }

    if (detectMobile()) {
      $("#markets.adWrapper").remove();

      // Make top menu items with no target open their submenu on click
      $("header #menu").on("click", 'a[href="#"]', function (e) {
        e.preventDefault();
        $(e.target).closest('a').siblings("input:checkbox").click();
      });
    }
    setTimeout(initTradingView, 1000);

    protectKlickTippForm();

    $("#experts").clickWhole(".expert", ".image a:first");
    $(".article-grid").clickWhole(".article", "a:first");
    $(".one-plus-n").clickWhole(".article", "a:first");
    loadMASession();

    $('input#louvre-toggle').each(function() {
        const $e = $(this).prop('checked', false);
        const $wrapper = $e.closest('#louvre')
        const version = $wrapper.data('version') || '0';
        const lsKey = 'louvre-last-closed-at-' + version;
        let delay = $e.data('delay') || 100;
        const lastClosed = localStorage.getItem(lsKey);
        const intervalS = parseInt($e.data('interval') || '5') * 60
        const now = Date.now();

        // If a user has closed the louvre manually, we wait +interval+ seconds to show it again
        if (lastClosed) {
            const diffS = (now - lastClosed) / (1000)
            const waitS = intervalS - diffS;
            if (waitS > 0) { // when <0, the interval has passed
                delay = delay + (waitS * 1000);
            }
        }

        setTimeout(function() {
            $wrapper.addClass('activated');
            $e.prop('checked', true);
        }, delay);

        $e.on('change', function() {
            localStorage.setItem(lsKey, Date.now());
        })
    });

    $('.ticker button.close').each(function() {
        const $button = $(this);
        const $ticker = $button.closest('.ticker');
        const id = $button.data('id') || '0';
        const version = $button.data('version') || '0';
        const lsKey = 'ticker-last-closed-at-' + id + '-' + version;
        const lastClosed = localStorage.getItem(lsKey);
        const intervalS = parseInt($button.data('interval') || '5')
        const now = Date.now();

        const remove = () => {
            const $all = $ticker.closest('#tickers');
            $ticker.remove();
            if ($all.find('.ticker').length == 0) {
                $all.remove();
            }
        }

        if (lastClosed) {
            if ((now - lastClosed) / (1000) < intervalS) {
                remove();
            }
        }
        $button.on('click', function() {
            localStorage.setItem(lsKey, Date.now());
            remove();
        });

    });

  })
} /* not in admin interface */
